import React, { useEffect } from 'react';
import { Box, Typography, Modal, IconButton, Button, Paper } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import { useCallback } from 'react';
import I18n from '@/rI18n';
import './UploadModal.css';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import Utils from '@/common/utils/utils';
import PropsType from 'prop-types';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: 3
};

const DropFile = ({ setUploadFile }) => {
    const onDrop = useCallback(acceptedFiles => {
        handleDragFileOnChange(acceptedFiles);
        return;
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: '.csv',
        multiple: false
    });

    const handleDragFileOnChange = files => {
        const file = files[0];
        if (file && file?.name?.endsWith('.csv')) {
            setUploadFile(file);
        } else {
            console.error('format file invalid.');
        }
    };

    return (
        <>
            <div className="formUpload" {...getRootProps()} data-cy="drop-file-input-upload">
                <input {...getInputProps()} draggable="false" accept=".csv"/>
                <label htmlFor="contained-button-file">
                    <Button variant="contained" component="span">
                        <div className="formUpload-item">
                            <img
                                src="/assets/image/icon-upload.svg"
                                alt=""
                                onDragStart={e => {
                                    e.preventDefault();
                                }}
                            />
                            <span className="formUpload-txt">{I18n.get('MSG-DRAG-DROP-FILE')}</span>
                        </div>
                    </Button>
                </label>
            </div>
        </>
    );
};
DropFile.propTypes = {
    setUploadFile: PropsType.func.isRequired
};

const SelectedFile = ({ selectedFile, setSelectedFile }) => {
    
    const deletedFileHandler = () => {
        setSelectedFile({});
    };

    return (
        <div className="lstName-file">
            <ul>
                <li>
                    <OverFlowTooltip
                        value={`${selectedFile?.name}(${Utils.formatBytes(
                            selectedFile?.size
                        )})`}
                    ></OverFlowTooltip>

                    <div className="lstName-item">
                        <IconButton onClick={() => deletedFileHandler()} className="itemDelete">
                            <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                        </IconButton>
                    </div>
                </li>
            </ul>
        </div>
    );
};
SelectedFile.propTypes = {
    selectedFile: PropsType.oneOfType([
        PropsType.object,
        PropsType.instanceOf(File)
    ]),
    setSelectedFile: PropsType.func.isRequired
};

function UploadModal({
    isOpen,
    closeHandler,
    uploadFile,
    setUploadFile,
    isDisable,
    uploadHandler
}) {

    return (
        <Modal
            open={isOpen}
            onClose={closeHandler}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={style} className="upload-modal-container">
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Typography
                        id="modal-title"
                        variant="h6"
                        fontWeight="bold"
                        className="upload-modal-title"
                    >
                        {I18n.get('UPLOAD-MODAL-TITLE')}
                    </Typography>
                        <IconButton className="close" onClick={() => closeHandler()}>
                            <img src="/assets/image/icon-close-panel.svg" alt="" />
                        </IconButton>
                </Box>
                <Typography className="upload-modal-description">
                    {I18n.get('UPLOAD-MODAL-DESCRIPTION')}
                </Typography>

                <Box>
                    {!Utils.isEmptyObject(uploadFile) && <SelectedFile selectedFile={uploadFile} setSelectedFile={setUploadFile} />}
                    <Paper
                        variant="outlined"
                        sx={{
                            my: 2,
                            p: 3,
                            borderStyle: 'dashed',
                            textAlign: 'center',
                            color: '#999',
                            borderRadius: 1.5,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        <DropFile uploadFiles={uploadFile} setUploadFile={setUploadFile} />
                    </Paper>
                </Box>
                <Box className="d-flex justify-content-center mt-2">
                    <Button
                        className="btn-send btn-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        data-cy="btn-submit-add-ticket"
                        onClick={() => uploadHandler()}
                        disabled={isDisable}
                    >
                        {I18n.get('EXCECUTION')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

UploadModal.propTypes = {
    isOpen: PropsType.bool.isRequired,
    closeHandler: PropsType.func.isRequired,
    uploadFile: PropsType.oneOfType([
        PropsType.object,
        PropsType.instanceOf(File)
    ]),
    setUploadFile: PropsType.func.isRequired,
    isDisable: PropsType.bool,
    uploadHandler: PropsType.func.isRequired
};

export default UploadModal;
